import React, {useEffect, useState} from 'react'
import {Button, Form, Input, InputNumber, message, Modal, Popconfirm} from "antd"
import {updateTenantSubFee} from "../../../../../../services/api/apiCustomerHub"
import parseToken from "../../../../../../helpers/parseToken"

const InitializationFeeEditModal = (props) => {
    const [formUpdateFee] = Form.useForm()
    const {isOpen, selectItem, onClose, onGetAgain} = props;
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)

    const _onUpdateInitializationFee = async () => {
        setLoading(true)
        try {
            const payload = {
                fee: formUpdateFee.getFieldValue('fee')
            }
            const response = await updateTenantSubFee(decodeToken.sub, selectItem.id, payload)

            setLoading(false)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            message.success('Cập nhật thành công!')
            onGetAgain()
            onClose()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    useEffect(() => {
        if (selectItem.id) {
            formUpdateFee.setFieldsValue({
                telco: selectItem.telco,
                type: selectItem.type,
                fee: selectItem.fee,
                description: selectItem.description,
            })
        }
        // eslint-disable-next-line
    }, [selectItem.id]);

    return (
        <Modal
            title="Sửa giá khởi tạo/sub"
            maskClosable={false}
            open={isOpen}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={onClose} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button key="submit" type="primary" htmlType='submit' form='updateFee' loading={loading}>
                        Sửa
                    </Button>
                </div>
            ]}
        >
            <Form layout="vertical" className='FormEdit' form={formUpdateFee} id='updateFee'
                  onFinish={_onUpdateInitializationFee}>
                <Form.Item
                    className='FormField'
                    name='telco'
                    label={<label className="Label">Telco</label>}
                >
                    <Input disabled/>
                </Form.Item>
                <Form.Item
                    className='FormField'
                    name='type'
                    label={<label className="Label">Loai phí</label>}
                >
                    <Input disabled/>
                </Form.Item>
                <Form.Item
                    name='fee'
                    className='FormField'
                    label={<label className="Label">Phí<span className="Required">*</span></label>}
                    rules={[
                        {
                            required: true,
                            message: 'Phí là bắt buộc'
                        }
                    ]}
                >
                    <InputNumber/>
                </Form.Item>
                <Form.Item
                    className='FormField'
                    name='description'
                    label={<label className="Label">Mô tả</label>}
                >
                    <Input disabled/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default InitializationFeeEditModal
